import React, { useEffect, useState } from 'react';
import { Image, message } from 'antd';
import { premiumpassApi } from 'apis/sales/premiumpassApis';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import RegisterButton from 'components/button/RegisterButton';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import MainTable from 'components/table/MainTable';
import PremiumPassInputModal from './PremiumPassInputModal';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

/**
 *
 * @returns 프리패스 목록화면
 */
const PremiumPassListPage = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const [datas, setDatas] = useState();
  const [visible, setVisible] = useState({
    register: false,
    update: false,
  });
  const [record, setRecord] = useState();

  const handleDelete = (record) => async () => {
    const res = await premiumpassApi.deletePremium(record.timedeal_id);
    if (!res) {
      return false;
    }
    message.success(t('premium.deleteSuccess'));
    fetchData();
  };

  const columnOrigin = [
    {
      title: t('premium.table.timedealID'),
      dataIndex: 'timedeal_id',
      key: 'timedeal_id',
    },
    {
      title: t('premium.table.conditions'),
      dataIndex: 'conditions',
      key: 'conditions',
      filters: [
        { text: t('premium.table.episodeProgressCondition'), value: 0 },
        { text: t('premium.table.hiddenEndingCondition'), value: 1 },
      ],
      onFilter: (value, record) => Number(value) === record.conditions,
      render: (text, record, index) =>
        text === 0 ? (
          <span>{t('premium.table.episodeProgressCondition')}</span>
        ) : (
          <span>{t('premium.table.hiddenEndingCondition')}</span>
        ),
    },
    {
      title: t('premium.table.episodeProgress'),
      dataIndex: 'episode_progress',
      key: 'episode_progress',
    },
    {
      title: t('premium.table.discount'),
      dataIndex: 'discount',
      key: 'discount',
    },
    {
      title: t('premium.table.deadline'),
      dataIndex: 'deadline',
      key: 'deadline',
    },
    {
      title: t('premium.table.update'),
      render: (text, record, index) => (
        <div>
          <CapsuleButton
            onClick={handleVisibleModal(record)}
            name='update'
            disabled={authUpdate}
          >
            {t('premium.table.editButton')}
            {/* {authUpdate === true ? '조회' : '수정'} */}
          </CapsuleButton>
          <DeletePopConfirm
            title={t('premium.table.deleteConfirm')}
            onConfirm={handleDelete(record)}
            disabled={authUpdate}
          />
        </div>
      ),
    },
  ];

  const handleVisibleModal = (record) => (e) => {
    let { name } = e.target;
    setVisible({ ...visible, [name]: true });
    if (record) {
      setRecord(record);
    }
  };

  const fetchData = async () => {
    const res = await premiumpassApi.read();
    setDatas(res);
  };

  useEffect(() => {
    fetchData().catch(console.log);
  }, []);

  return (
    <DefaultLayout>
      <TableToolbar>
        <div />
        <RegisterButton
          name='register'
          onClick={handleVisibleModal()}
          disabled={authUpdate}
        >
          {t('premium.headers.addButton')}
        </RegisterButton>
      </TableToolbar>

      <MainTable columns={columnOrigin} dataSource={datas} />

      {visible.register && (
        <PremiumPassInputModal
          visible={visible}
          setVisible={setVisible}
          fetchData={fetchData}
        />
      )}

      {visible.update && (
        <PremiumPassInputModal
          visible={visible}
          setVisible={setVisible}
          fetchData={fetchData}
          record={record}
        />
      )}
    </DefaultLayout>
  );
};

export default PremiumPassListPage;
